import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { HouseDoor, Person, Award, Briefcase, Envelope } from "react-bootstrap-icons";

import logo from '../assets/img/skblogo.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon4 from '../assets/img/nav-icon4.png';
import navIcon5 from '../assets/img/nav-icon5.png';
import {
  BrowserRouter as Router
} from "react-router-dom";

export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
    setExpanded(false);
  }

  return (
    <Router>
      <Navbar expanded={expanded} onToggle={setExpanded} expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand href="/" style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={logo}
              alt="Logo"
              style={{
                width: '100px',  // Adjust size as you like (try 40px to 50px)
                height: '100px',
                marginRight: '10px'  // Some space between logo and text
              }}
            />
            <h2 style={{ fontSize: '1.5rem', margin: 0, color: '#fff' }}>Shraddha Bonde</h2>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <div className="drawer-header d-md-none">
              <img src={logo} alt="Logo" className="drawer-logo" />
              <h3>Shraddha Bonde</h3>
              <p>Portfolio Menu</p>
            </div>
            <Nav className="ms-auto">
              <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>
                <HouseDoor className="nav-icon" /> Home
              </Nav.Link>
              <Nav.Link href="#about" className={activeLink === 'about' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('about')}>
                <Person className="nav-icon" /> About
              </Nav.Link>
              <Nav.Link href="#projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')}>
                <Award className="nav-icon" /> Certificates
              </Nav.Link>
              <Nav.Link href="#project" className={activeLink === 'project' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('project')}>
                <Briefcase className="nav-icon" /> Projects
              </Nav.Link>
              <Nav.Link href="#connect" className={activeLink === 'connect' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('connect')}>
                <Envelope className="nav-icon" /> Contact
              </Nav.Link>
            </Nav>
            
            <div className="navbar-text">
              <div className="social-icon">
                <a href="https://www.linkedin.com/in/shraddha-bonde-1483a8270" onClick={() => setExpanded(false)}><img src={navIcon1} alt="" /></a>
                <a href="https://github.com/Skbonde05" onClick={() => setExpanded(false)}><img src={navIcon4} alt="" /></a>
                <a href="mailto:skbonde05@gmail.com" onClick={() => setExpanded(false)}><img src={navIcon5} alt="" /></a>
              </div>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  )
}
